import useEditorText from 'features/aiWriter/AiWriterTextEditor/hooks/useEditorText';
import { getWordCount } from 'utils/getWordCount';

export const useEditorWordsCount = () => {
  const text = useEditorText();

  return getWordCount(text);
};
